'use client'

// Errors in the root layout itself (it renders the providers C500 needs)
export default function GlobalError() {
  return (
    <html>
      <body>
        <h1>500</h1>
      </body>
    </html>
  )
}
